import * as Sentry from "@sentry/browser";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "vite/modulepreload-polyfill"; // https://github.com/MrBin99/django-vite?tab=readme-ov-file#assets
import CaApp from "./App";
import "./index.css";
import KaApp from "./ka/App";

const root = createRoot(document.getElementById("root"));
if (window["SENTRY_DSN"]) Sentry.init({ dsn: window["SENTRY_DSN"] });
const App = window["CA"]?.site?.prefix == "ka" ? KaApp : CaApp;
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
